import buttonToolbar from './template/buttonToolbar.vue';
import Vue from 'vue';
import Base from './base.js';
import jQuery from 'jquery';
import Gikam from '../core/gikam-core';

let defaultOptions = {
    renderTo: void 0,
    $root: void 0,
    position: 'top'
};

export default class BtnToolbar extends Base {

    constructor(param) {
        super();
        this.initialize(param, defaultOptions).init();
    }

    createModel() {
        let _this = this;
        let container = null;
        if (this.options.$root && this.options.$root.classList.contains('body')) {
            const $window = jQuery(this.options.$root).closest('.window');
            const window = Gikam.getInstance($window[0]);
            window && window.showHeader();
            container = $window.find('.toolbar');
        } else {
            container = this.options.renderTo;
        }
        return new Vue({
            el: jQuery('<button-toolbar :options="options"/>').appendTo(container)[0],
            components: { buttonToolbar },
            data() {
                return {
                    options: _this.options
                };
            }
        });
    }

    init() {
        this.model = this.createModel();
    }

}

